import { render, staticRenderFns } from "./BoMQuotation.vue?vue&type=template&id=1faf06cc&"
import script from "./BoMQuotation.vue?vue&type=script&lang=js&"
export * from "./BoMQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports